<div class="tabela-skeleton">
  <div class="tabela-header-skeleton"></div>
  @for (item of linhas; track item){
    <div class="tabela-item-skeleton"></div>
  }
</div>